import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/callback")({
	component: CallbackPage,
	ssr: false,
});

function CallbackPage() {
	return <AuthPage view="CALLBACK" />;
}
